import Form from 'react-bootstrap/Form';

function CheckboxTnc(props) {
  return (
    <>
      {props.tncList.map((rule) => <PrintCheckbox key={rule.TnC_id} id={rule.TnC_id} description={{__html:rule.TnC_Description}} defaultValue={rule.IsDefault} onChangeEvent={props.passChildData} />)}
    </>
  );
}

function PrintCheckbox(props){
  return <>
  <div>
    <span className="cbxName"><Form.Check type="checkbox" name={"cbxTnc"+props.id} onChange={e => props.onChangeEvent(e)} defaultChecked={props.defaultValue === true}>
        </Form.Check></span>
    <span className="cbxDesc"><div dangerouslySetInnerHTML={ props.description}></div></span>
  </div>
  </>
}

export default CheckboxTnc;